import { render, staticRenderFns } from "./RegisterSuccesForm.vue?vue&type=template&id=0f6f100a&scoped=true"
import script from "./RegisterSuccesForm.vue?vue&type=script&lang=js"
export * from "./RegisterSuccesForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterSuccesForm.vue?vue&type=style&index=0&id=0f6f100a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f100a",
  null
  
)

export default component.exports